import React, { Component } from "react";
import { Map, Marker, ZoomControl, Popup, TileLayer} from 'react-leaflet'
import ReactDOMServer from 'react-dom/server';
import L from 'leaflet';
import Icon from './Icon'

const debug = process.env.GATSBY_DEBUG;
const MAPBOX_ACCESS_TOKEN = process.env.GATSBY_MAPBOX_TOKEN;

export default class WomenMap extends Component {
  constructor(props) {
    super(props);
    this.showMessage = this.showMessage.bind(this);
    this.mapRef = React.createRef();

    this.state = {
      currentUser: {
        userId: null,
        prename: "", 
        surname: "", 
        mail: "",
        showMail: false,
        company: "", 
        category: "", 
        street: "", 
        number: "", 
        zipcode: "", 
        city: "", 
        country: "", 
        showAddress: false,
        phone: "", 
        showPhone: false,
        website: "",
        citation: "",
        description: "",
        cover: "",
        pic1: "",
        facebook: "",
        instagram: "",
        twitter: "",
        xing: "",
        linkedin: "",
        position: [],
        isActive: false,
      },
      message: "",
      hasLocation: false,
      latlng: {
        lat: 0,
        lng: 0,
      },
    };
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  componentDidMount() {
    if (this.props.user !== null) {
      this.setState({
        currentUser: this.props.user,
      });
    }
  }

  handleClick = () => {
    const map = this.mapRef.current
    if (map != null) {
      map.leafletElement.locate()
    }
  }

  handleLocationFound = (e) => {
    this.setState({
      hasLocation: true,
      latlng: e.latlng,
    })
    if (debug) console.log(e.latlng);
  }


  render() {
    if (typeof window !== 'undefined') {
      const womenmarker = this.state.currentUser.position && this.state.currentUser.showAddress  ? (
        <Marker position={this.state.currentUser.position} icon={L.divIcon({iconUrl: this.state.currentUser.pic1, className: 'custom-icon',html: ReactDOMServer.renderToString(<Icon image={this.state.currentUser.pic1}/>), iconSize: [40, 40], iconAnchor: [20, 20], popupAnchor: [0, -25]})}> 
          <Popup>
          <h4>{this.state.currentUser.prename} {this.state.currentUser.surname}</h4>
          {this.state.currentUser.company}<br/>
          {this.state.currentUser.street} {this.state.currentUser.number}<br/>
          {this.state.currentUser.zipcode} {this.state.currentUser.city}<br/>
          {this.state.currentUser.country}<br/><br/>
          <a href={"https://www.google.de/maps/place/"+ this.state.currentUser.street + "+" + this.state.currentUser.number + ",+"+ this.state.currentUser.zipcode + "+" + this.state.currentUser.city + ",+" + this.state.currentUser.country} target="_blank">Google Maps</a>
          </Popup>
        </Marker>
      ) : null

      const mymarker = this.state.hasLocation ? (
        <Marker position={this.state.latlng}>
          <Popup>Mein Standort</Popup>
        </Marker>
      ) : null

      return (
        <div>
        {this.state.currentUser.position && this.state.currentUser.showAddress ? (
        <div className="cards-top profile-map">
        <Map 
          center={this.state.currentUser.position}
          /* onClick={this.handleClick}
          onLocationfound={this.handleLocationFound} */
          ref={this.mapRef}
          tap={false}
          scrollWheelZoom={false}
          dragging={false}
          touchZoom={false}
          zoomControl={true}
          zoom={13}>
{/*         <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        /> */}
          <TileLayer
            url={"https://api.mapbox.com/styles/v1/worlfullofwomen/ckqr18m5v7l3i18n91bxnxrxq/tiles/256/{z}/{x}/{y}@2x?access_token="+MAPBOX_ACCESS_TOKEN}
            attribution='<a target="_blank" href="https://www.mapbox.com/">Mapbox</a>'
          />
        {womenmarker}
        {mymarker}
      </Map>
      </div>) : (<span></span>)}
      </div>
      )
  }
  return null
  }
}